module.exports = __webpack_public_path__ + "static/media/medal.bc130bad.svg";